export default __webpack_public_path__ + "static/media/science-technology-safco.5b19b637.jpg";